import { EnableFullscreenViewAction, DisableFullscreenViewAction } from './view-actions';
import { FullscreenToggleService } from './fullscreen-toggle.service';
import { Provider } from '@angular/core';
import { AdditionalTableConfigProvider } from '@antony/ng-ui';
import { TableConfigProvider } from './table-config.provider';

export const PROVIDERS: Provider[] = [FullscreenToggleService, DisableFullscreenViewAction, EnableFullscreenViewAction, { provide: AdditionalTableConfigProvider, useClass: TableConfigProvider }];
